import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { LoginService } from 'src/app/services/login.service';

@Component({
    selector: 'app-enterprise-dashboard',
    templateUrl: './enterprise-dashboard.component.html',
    styleUrls: ['./enterprise-dashboard.component.css'],
})
export class EnterpriseDashboardComponent implements OnInit {
    enterpriseName?: string = '';
    sessionUser$ = this.loginService.sessionUser.asObservable();

    constructor(public loginService: LoginService) {}

    ngOnInit() {
        this.sessionUser$
            .pipe(take(1)) // take only once to avoid memory leaks or duplicate requests
            .subscribe((user) => {
                if (user) {
                    this.enterpriseName = user.enterprise.businessName;
                }
            });
    }
}
